import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import UserScreen from "../index";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import {
  ICreateAndUpdateUser,
  IFindUserInformation,
} from "../../../types/common.interface";

const UserContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedUser, setSelectedUser] = React.useState<any>();
  const [requestUser, setRequestUser] = React.useState<IFindUserInformation>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    search: { base: "", value: "" },
    filters: {
      province: undefined,
      city: undefined,
    },
  });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // const resultUser = { data: { result: { docs: [] } } };
  const resultUser = useQuery(
    [
      values.useQueryKeys.getAllUser,
      requestUser?.page,
      requestUser?.search?.value,
      requestUser?.filters,
    ],
    () =>
      api.post.administrator.getAllAdmin({
        filters: requestUser?.filters,
        search: requestUser?.search,
        limit: requestUser?.limit,
        page: requestUser?.page,
      })
  );

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateUser) {
    setIsLoading(true);
    const result = await api.post.administrator.createAdmin(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultUser.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateUser) {
    setIsLoading(true);
    const result = await api.put.administrator.updateAdmin(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultUser.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // async function deleteFunction(userId: string) {
  //   setIsLoading(true);
  //   const result = await api.dele.administrator.deleteUser(userId);
  //   if (result) {
  //     utils.successHandler(Number(2010)); // result.CODE === 2021
  //     // resultUser.refetch();
  //     setShowModal("NONE");
  //   }
  //   setIsLoading(false);
  //   return false;
  // }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.UserScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        setIsLoading,
        updateFunction,
        createFunction,
        requestUser,
        selectedUser,
        setRequestUser,
        setSelectedUser,
      }}
    >
      <UserScreen rqUser={resultUser} />
      {/* <DeleteModal
        open={showModal === "DELETE"}
        user={selectedUser}
        data={selectedUser}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      /> */}
    </Context.UserScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default UserContainer;
